import React from "react";
import { ServicesHeaderStyles } from "./styles";

const ServicesHeader = () => {
  return (
    <ServicesHeaderStyles>
      <h1>services</h1>
      <h3>what I can do for you</h3>
    </ServicesHeaderStyles>
  );
};

export default ServicesHeader;
